import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import FormControl from '@material-ui/core/FormControl';
import { useGetUser } from '../../hooks/useGetUser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import TextField from '@material-ui/core/TextField';
import { useDispatch } from "react-redux";

import Card from './components/Card';
import styles from './styles.module.scss';
import { listarSimplificadaParceiros, getListaParceirosPesquisar } from '../../services/api-auto';
import ModalLoading from '../../components/ModalLoading';

import { showMsgE as showMsgEAction } from '../../store/actions/snackbarActions.js';

import services from '../../services';


const Parceiros = props => {
    const dispatch = useDispatch();
    const showMsgE = (msg) => dispatch(showMsgEAction(msg));

    const history = useHistory();
    //const [dados, setDados] = useState()
    const [parceiros, setParceiros] = useState([])
    const [maxPage, setMaxPage] = useState(0)

    const [buscar, setBuscar] = useState('')
    const [ativarBuscar, setAtivarBuscar] = useState(false)
    const [pagina, setPagina] = useState(1)
    const [modalLoading, setModalLoading] = useState(false);
    const [permiteAlterarParceiro, setPermiteAlterarParceiro] = useState(services.storage.getClaimValues("PDV", "Alterar"));
    const [permiteVisualizarParceiro, setPermiteVisualizarParceiro] = useState(services.storage.getClaimValues("PDV", "Visualizar"));

    const user = useGetUser();

    const getParceiros = async (novaPagina = 1, buscar) => {
        setModalLoading(true)
        const data = await listarSimplificadaParceiros(novaPagina, buscar ?? '');
        setMaxPage(data.data.maxPage)
        setParceiros([...parceiros, ...data.data.data])
        setModalLoading(false)
        setPagina(novaPagina)
    }
    const addPage = async () => {
        getParceiros(pagina + 1, buscar)
    }

    const findParceiros = async () => {
        if (buscar !== '') {
            setModalLoading(true)
            try {
                const info = await getListaParceirosPesquisar(1, buscar)
                setPagina(1)
                setParceiros(info.data.data)
                setMaxPage(info.data.maxPage)
                setAtivarBuscar(true)
            } catch (e) {
                showMsgE("Ocorreu um erro e não foi possível carregar dados")
            } finally {
                setModalLoading(false)
            }
        } else {
            setAtivarBuscar(false)
            getParceiros();
        }
    }

    useEffect(() => {
        getParceiros()
    }, [])


    return (
        <div className={styles.wrapper}>
            <div className={styles.title}>
                Pontos de Venda
            </div>
            <div className={styles.buttonWrapper}>
                {(user.perfilAcesso === 'Master') && (
                    <>
                        <button className={`btnInvert ${styles.btAdd}`} onClick={() => { history.push('/parceiros/detalhes') }}>
                            Adicionar Parceiros
                        </button>
                        <button className={`btnInvert ${styles.btAdd}`} onClick={() => { history.push('/parceiros/importar') }}>
                            Importar base de parceiros
                        </button>
                    </>
                )}
            </div>
            <div className={styles.subTitle}>
                Lojas cadastradas
            </div>
            <div className={styles.buscar}>
                <FormControl>
                    <TextField
                        type="text"
                        size="small"
                        onChange={(e) => { setBuscar(e.target.value) }}
                        label="Faça sua busca"
                        value={buscar}
                        variant="filled"
                        multiline
                        className="customFilledInput"
                        onKeyDown={
                            (e) => {
                                if (e.key === 'Enter') {
                                    findParceiros();
                                    e.preventDefault();
                                }
                            }
                        }
                        InputProps={{
                            endAdornment: (
                                <button onClick={findParceiros} className={styles.searcButton}>
                                    <FontAwesomeIcon icon={faSearch} />
                                </button>
                            )
                        }}
                    />
                </FormControl>
            </div>
            <div className={styles.acoesWrapper}>
                {
                    Boolean(parceiros.length) ?
                        parceiros.map(
                            (usuario) => {
                                return (<Card usuario={usuario}
                                    key={usuario.id}
                                    permiteAlterar={permiteAlterarParceiro}
                                    permiteVisualizar={permiteVisualizarParceiro} />)
                            }
                        )
                        :
                        (
                            !modalLoading &&
                            (
                                <div>
                                    Nenhum registro encontrado
                                </div>
                            )
                        )
                }
            </div>
            {(pagina < maxPage) && (
                <div className={styles.verMaisWrapper}>
                    <button className={`customButton ${styles.verMaisButton}`} onClick={addPage} >
                        Ver mais
                    </button>
                </div>
            )}
            <ModalLoading
                open={modalLoading}
                size="lg"
            />
        </div>
    );

}

export default Parceiros;